export class SaveableSettingsProvider {
  constructor() {}

  createSaveableSettings(/*settings*/) {
    return {};
  }

  applySaveableSettings(/*settings, saveableSettings*/) {}
}
